import { matchPath, useLocation } from 'react-router-dom';
import useHelmet from 'utils/useHelmet';

const getHelmetConfig = pathname => {
  // reuse react-router logic to intuitivelly check if pathname matches
  const route = pattern => matchPath(pattern, pathname);

  if (route('/about')) {
    return {
      canonicalLink: '/about',
      metaDescription:
        'We saw an opportunity to reinvent the hair care industry by creating custom products ' +
        'that are inclusive of all hair types, needs and goals using natural ingredients.',
      title: 'Learn More About Our Mission at Prose | Prose Hair',
    };
  }
  if (route('/consultation/:slug')) {
    return {
      metaDescription:
        'Our free consultation takes your hair needs and goals, local climate, water quality, ' +
        'lifestyle and preferences into account to create custom hair care just for you.',
      title: 'Take Our Consultation to Create Your Custom Formula | Prose Hair',
      noIndex: true,
    };
  }
  if (route('/consultation')) {
    return {
      metaDescription:
        'Our free consultation takes your hair needs and goals, local climate, water quality, ' +
        'lifestyle and preferences into account to create custom hair care just for you.',
      title: 'Take Our Consultation to Create Your Custom Formula | Prose Hair',
    };
  }
  if (
    route('/checkout/contact-address') ||
    route('/checkout/payment') ||
    route('/checkout/confirmation')
  ) {
    return {
      metaDescription: 'Fill out delivery infos to complete your order',
      title: 'Checkout | Prose Hair',
    };
  }
  if (route('/checkout/success')) {
    return {
      metaDescription:
        'Thanks for ordering Prose! We’ll get started making your products and send an email confirmation as soon as they ship!',
      title: 'Good Hair Days Only | Prose Hair',
    };
  }
  if (route('/checkout')) {
    return {
      metaDescription:
        'They’ll be made to order in our NY lab with a blend of premium ingredients selected just for you.',
      title: 'Select your custom products | Prose Hair',
    };
  }
  if (route('/contact')) {
    return {
      canonicalLink: '/contact',
      metaDescription:
        'Have a question about your order? Need help during your consultation? Our team of ' +
        'in-house experts is here for you. 100% satisfaction guaranteed on all orders.',
      title: 'Get Help from Hair Care Specialists | Contact Prose Hair team',
    };
  }
  if (route('/faq')) {
    return {
      canonicalLink: '/faq',
      metaDescription:
        'Easily find answers to commonly asked questions about our products and brand.',
      title: 'FAQs Prose | Product and Customer Service Questions',
    };
  }
  if (route('/gift')) {
    return {
      canonicalLink: '/gift',
      metaDescription:
        'The most memorable gift is personalized, and with Prose they get custom hair care ' +
        'made just for their hair goals and needs. It’s the gift that already has their name on it.',
      title: 'Give the Gift of Happy Hair Days | Prose Hair',
    };
  }
  // mandatory: always before /ingredients otherwise will have two descriptions
  if (route('/ingredients/:slug')) {
    return {
      canonicalLink: null,
      metaDescription: null,
      title: null,
    };
  }
  if (route('/ingredients')) {
    return {
      canonicalLink: '/ingredients',
      metaDescription:
        'Discover the natural ingredients thoughtfully curated from all around the world to ' +
        'create custom hair care that meets clean beauty standards. Cruelty-free.',
      title: 'Ingredient Dictionary: Best Ingredients for Hair Care | Prose Hair',
    };
  }
  if (route('/pages/curl-cream')) {
    return {
      canonicalLink: '/pages/curl-cream',
      metaDescription:
        'Whether you have waves, curls or coils, Prose custom curl cream will define your natural texture while keeping your strands hydrated and frizz-free.',
      title: 'Custom Curl Cream As Unique As You | Prose Hair',
    };
  }
  if (route('/pages/dry-shampoo')) {
    return {
      canonicalLink: '/pages/dry-shampoo',
      metaDescription:
        'Care for your scalp while refreshing your roots. Prose custom dry shampoo is the flexible solution made to help you meet your day-off hair goals.',
      title: 'Custom Dry Shampoo Means No Compromises | Prose Hair',
    };
  }
  if (route('/pages/oil')) {
    return {
      canonicalLink: '/pages/oil',
      metaDescription:
        'Each bottle is a custom blend of natural oils formulated for your unique hair. ' +
        'Finally a hair oil for everyone, no matter your hair type, goals, environment or lifestyle.',
      title: 'Introducing the First Ever Custom Hair Oil | Prose Hair',
    };
  }
  if (route('/pages/brushes')) {
    return {
      canonicalLink: '/pages/brushes',
      metaDescription:
        'A limited collection of four monogrammed brushes made with care; the perfect gift to any haircare routine.',
      title: 'Personalized Brushes | Prose Hair',
    };
  }
  if (route('/pages/supplements')) {
    return {
      canonicalLink: '/pages/supplements',
      metaDescription:
        'Prose’s Root Source™ is a plant-based 100% natural hair supplement made with clinically-proven ingredients that are customized for you to help grow your best hair.',
      title:
        'Prose plant-based hair supplements for longer, stronger, fuller hair | Prose Root Source™',
    };
  }
  if (route('/pages/supplements-search')) {
    return {
      canonicalLink: '/pages/supplements-search',
      metaDescription:
        'Prose’s Root Source™ is a plant-based 100% natural hair supplement made with clinically-proven ingredients that are customized for you to help grow your best hair.',
      title:
        'Prose plant-based hair supplements for longer, stronger, fuller hair | Prose Root Source™',
    };
  }
  if (route('/pages/stylist-content-call')) {
    return {
      canonicalLink: '/pages/stylist-content-call',
      metaDescription:
        "Calling all hairstylists to submit your best hair-related photos and videos. You'll be paid for any entries selected to live on our social channels, blog and more.",
      title: 'Open Call for Original Photos and Videos from Professional Stylists',
    };
  }
  if (route('/pages/*')) {
    // by default landing pages are not indexed
    return { noIndex: true };
  }
  if (route('/promotion-terms/*')) {
    return { noIndex: true };
  }
  if (route('/terms/*')) {
    return { noIndex: true };
  }
  if (route('/4th-of-july')) {
    return { noIndex: true };
  }
  if (route('/reviews')) {
    return {
      canonicalLink: '/reviews',
      metaDescription:
        'See why people love prose custom hair care. Custom Made For You. Paraben & Sulfate Free.',
      title: 'Prose reviews | Prose Hair',
    };
  }
  if (route('/selfie')) {
    return {
      metaDescription:
        'Upload 2 photos and our team of experts will make sure we didn’t miss anything in your consultation.',
      title: 'Upload Your Photos | Prose Hair',
    };
  }
  if (route('/products/custom-hair-mask')) {
    return {
      canonicalLink: '/products/custom-hair-mask',
      metaDescription:
        'A formula created just for you. Our custom pre-shampoo hair mask is freshly made to truly' +
        ' meet all of your unique hair needs and goals.',
      title: 'Custom Hair Mask | Prose Hair',
    };
  }
  if (route('/products/custom-scalp-mask')) {
    return {
      canonicalLink: '/products/custom-scalp-mask',
      metaDescription:
        'A formula created just for you. Our custom pre-shampoo scalp mask is freshly made to truly' +
        ' meet all of your unique hair needs and goals.',
      title: 'Custom Scalp Mask | Prose Hair',
    };
  }
  if (route('/products/custom-shampoo')) {
    return {
      canonicalLink: '/products/custom-shampoo',
      metaDescription:
        'A formula created just for you. Our custom shampoo is freshly made to truly ' +
        'meet all of your unique hair needs and goals.',
      title: 'Custom Shampoo | Prose Hair',
    };
  }
  if (route('/products/custom-conditioner')) {
    return {
      canonicalLink: '/products/custom-conditioner',
      metaDescription:
        'A formula created just for you. Our custom conditioner is freshly made to truly ' +
        'meet all of your unique hair needs and goals.',
      title: 'Custom Conditioner | Prose Hair',
    };
  }
  if (route('/products/custom-hair-oil')) {
    return {
      canonicalLink: '/products/custom-hair-oil',
      metaDescription:
        'A formula created just for you. Our custom hair oil is freshly made to truly ' +
        'meet all of your unique hair needs and goals.',
      title: 'Custom Hair Oil | Prose Hair',
    };
  }
  if (route('/products/custom-dry-shampoo')) {
    return {
      canonicalLink: '/products/custom-dry-shampoo',
      metaDescription:
        'A formula created just for you. Our custom dry shampoo is freshly made to truly ' +
        'meet all of your unique hair needs and goals.',
      title: 'Custom Dry Shampoo | Prose Hair',
    };
  }
  if (route('/products/custom-shimmer-hair-oil')) {
    return {
      canonicalLink: '/products/custom-shimmer-hair-oil',
      metaDescription:
        'A formula created just for you. Our custom shimmer hair oil is freshly made to truly ' +
        'meet all of your unique hair needs and goals. 100% Satisfaction.',
      title: 'Custom Shimmer Hair Oil | Prose Hair',
    };
  }
  if (route('/products/custom-hair-supplements')) {
    return {
      canonicalLink: '/products/custom-hair-supplements',
      metaDescription:
        'A formula created just for you. Our custom hair supplements is freshly made to truly ' +
        'meet all of your unique hair needs and goals. 100% Satisfaction.',
      title: 'Custom Hair Supplements | Prose Hair',
    };
  }
  if (route('/products')) {
    return {
      canonicalLink: '/products',
      metaDescription:
        'Products created just for you. Our custom hair care is freshly made to truly ' +
        'meet all of your unique hair needs and goals.',
      title: 'Custom Hair Care Products | Prose Hair',
    };
  }
  return {};
};

const defaultConfig = {
  canonicalLink: null,
  metaDescription:
    'Your hair is unique. Get hair care 100% custom made for your hair type, goals & ' +
    'lifestyle. Natural active ingredients. Sulphate-free. GMO-free. Free Shipping (US only).',
  title: 'Custom Hair Care | Prose Hair',
  noIndex: false,
};

const Helmet = () => {
  const { pathname } = useLocation();
  const config = {
    ...defaultConfig,
    ...getHelmetConfig(pathname),
  };

  useHelmet(config);

  return null;
};

Helmet.propTypes = {};

export default Helmet;
